
import { SchedulingRefinements, SchedulingRefiners, WorkOrderBoardSort } from '../scheduling';
import { PagingOptions } from '../shared';
import { AllocationViewJobsFilters } from './allocation.view';
import { SchedulerWorkSummary } from './scheduler.work.summary';

export enum SchedulerViewType {
    New = 'New',
    OnHold = 'On Hold',
    InProgress = 'In Progress',
    ActionRequired = 'Action Required',
    Recent = 'Recent',
    Incomplete = 'Incomplete',
    Search = 'Search'
}

export enum SchedulerViewComponent {
    Items = 'Items',
    Count = 'Count',
    Refiners = 'Refiners'
}

export interface SchedulerViewRequest {
    /** job view id */
    viewId?: string;
    /** custom filters */
    filters?: AllocationViewJobsFilters;

    view: SchedulerViewType;
    paging?: PagingOptions;
    refinements?: SchedulingRefinements;
    refiners?: boolean;
    timezone: string;
    count?: boolean;

    component?: SchedulerViewComponent;
}

export interface SchedulerWorkView {
    work: SchedulerWorkSummary[];
    refiners: SchedulingRefiners;
    view: SchedulerViewType;
    sorts?: WorkOrderBoardSort[];
    refinements?: SchedulingRefinements;
    paging?: PagingOptions;
    count?: number;
}
